import { Groupper, Icon } from 'react-frontier';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../hooks';

var Profile =()=>{
	var navigate = useNavigate();
	var { user } = useUser();

	var initials = `${user?.first_name?.[0] || ''}${user?.last_name?.[0] || ''}`.toUpperCase() || '?';

	return <div className="team-check-screen">
		<Groupper title="Mi perfil" titleSize="small" style={{ margin: 0, padding: 0 }}>
			<div className="team-profile-hero">
				<div className="team-profile-avatar">{initials}</div>
				<div className="team-profile-name">{user?.first_name} {user?.last_name}</div>
				<div className="team-profile-email">{user?.email}</div>
			</div>
			<Groupper.Divider
				type="line text"
				text="Opciones"
				textStyle={{ fontWeight: 600, fontSize: 16, color: '#5f5a55' }}
			/>
			<div className="team-menu-card">
				<button className="team-menu-row" type="button" onClick={()=>navigate('/profile/accounts')}>
					<div className="team-menu-icon">
						<Icon name="credit-card" size={18} style={{ margin: 0 }} />
					</div>
					<div className="team-menu-texts">
						<div className="team-menu-title">Mis Cuentas</div>
						<div className="team-menu-subtitle">Administra tus cuentas bancarias</div>
					</div>
					<Icon name="chevron-right" size={18} style={{ margin: 0 }} />
				</button>
			</div>
		</Groupper>
	</div>;
};

export default Profile;
